interface SlideOriginInput {
  origin?: string | null;
  isCompleted?: boolean;
}

export function isReceivedExternalSlide(slide: SlideOriginInput): boolean {
  return (
    slide.isCompleted === true &&
    (slide.origin === "sending_client" || slide.origin === "external_provider")
  );
}
